var _g, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCenterwellMapIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 37,
    viewBox: "0 0 34 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1488_17722)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    width: 30,
    height: 30,
    rx: 15,
    fill: "#003DA5",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2257 32.3284C17.0164 32.6461 16.5504 32.6461 16.3412 32.3283L14.1499 29L19.4172 29L17.2257 32.3284Z",
    fill: "#003DA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1775 15.3133C19.9665 15.3133 19.7512 15.3305 19.5446 15.3563C19.5317 15.2358 19.5274 15.1195 19.5274 14.999C19.5274 14.8784 19.536 14.7622 19.5446 14.6416C19.7555 14.6675 19.9665 14.6804 20.1775 14.6804C22.5325 14.6804 24.5775 13.0831 25.1415 10.797L25.2879 10.1985L24.6938 10.0435C24.2675 9.93158 23.8327 9.87561 23.3936 9.87561C21.0385 9.87561 18.9935 11.4729 18.4295 13.759C18.3305 14.1637 18.2788 14.577 18.2788 14.9947C18.2788 15.4123 18.3305 15.8256 18.4295 16.2303C18.9978 18.5164 21.0385 20.1137 23.3936 20.1137C23.8327 20.1137 24.2718 20.0577 24.6938 19.9458L25.2879 19.7908L25.1415 19.1924C24.5732 16.9062 22.5325 15.309 20.1775 15.309M23.3936 11.1242C23.5012 11.1242 23.6088 11.1285 23.7122 11.1371C23.1008 12.5148 21.7274 13.4318 20.1732 13.4318C20.0655 13.4318 19.9579 13.4275 19.8546 13.4189C20.4659 12.0412 21.8393 11.1242 23.3936 11.1242ZM23.3936 18.8652C21.8393 18.8652 20.4659 17.9481 19.8546 16.5704C19.9622 16.5618 20.0655 16.5575 20.1732 16.5575C21.7274 16.5575 23.1008 17.4745 23.7122 18.8523C23.6045 18.8609 23.5012 18.8652 23.3936 18.8652Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2485 6.90837C18.0289 6.5252 17.762 6.17647 17.452 5.86648L17.0172 5.43164L16.5737 5.85787C14.8774 7.48959 14.5158 10.0599 15.6954 12.1006C15.8031 12.2857 15.9236 12.458 16.0485 12.6259C15.9494 12.6948 15.8504 12.7636 15.7471 12.8196C15.6438 12.8799 15.5361 12.9315 15.4285 12.9832C15.3467 12.7895 15.252 12.5957 15.1486 12.4149C13.969 10.3742 11.5666 9.40547 9.30199 10.0556L8.71216 10.2278L8.87576 10.8219C8.99201 11.2439 9.15991 11.6529 9.37949 12.0317C10.3137 13.6462 12.0144 14.5934 13.8054 14.5934C14.2747 14.5934 14.7526 14.5288 15.2261 14.3911C15.6265 14.2748 16.0097 14.1112 16.3714 13.9046C16.733 13.6979 17.0645 13.4439 17.3659 13.1554C19.0622 11.5237 19.4239 8.95341 18.2442 6.91268M10.4644 11.4032C10.4128 11.3084 10.3611 11.218 10.3181 11.119C11.8163 10.9597 13.2973 11.6873 14.0766 13.0349C14.1283 13.1253 14.1799 13.22 14.223 13.319C12.7247 13.4783 11.2437 12.7507 10.4644 11.4032ZM16.9956 7.26141C17.0559 7.34752 17.1119 7.43793 17.1679 7.53265C17.9471 8.87592 17.8395 10.5249 16.9483 11.7433C16.888 11.6572 16.832 11.5668 16.7761 11.472C15.9968 10.1288 16.1044 8.47982 16.9956 7.26141Z",
    fill: "#78BE20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.37 16.8446C17.0687 16.5561 16.7372 16.3021 16.3755 16.0954C16.0139 15.8888 15.6307 15.7252 15.2303 15.6089C12.9657 14.9588 10.5633 15.9275 9.38364 17.9683C9.16406 18.3471 8.99616 18.7561 8.87991 19.1781L8.71631 19.7722L9.30614 19.9444C9.77973 20.0822 10.2533 20.1468 10.7269 20.1468C12.5179 20.1468 14.2185 19.1996 15.1528 17.5851C15.2604 17.3999 15.3508 17.2105 15.4326 17.0125C15.5403 17.0641 15.6479 17.1158 15.7512 17.1761C15.8546 17.2363 15.9536 17.3009 16.0483 17.3698C15.9191 17.5377 15.8029 17.7142 15.6953 17.8994C14.5156 19.9401 14.8773 22.5061 16.5736 24.1421L17.017 24.5683L17.4519 24.1292C17.7618 23.8192 18.0288 23.4662 18.2483 23.0873C19.428 21.0466 19.0664 18.4806 17.37 16.8446ZM14.0722 16.9608C13.2929 18.3041 11.8162 19.036 10.3136 18.8767C10.3609 18.782 10.4083 18.6872 10.4643 18.5925C11.2392 17.245 12.7203 16.5174 14.2228 16.6767C14.1755 16.7714 14.1281 16.8661 14.0765 16.9608M17.172 22.463C17.1203 22.5577 17.0601 22.6439 16.9998 22.7343C16.1086 21.5159 16.0009 19.8669 16.7802 18.5236C16.8319 18.4332 16.8922 18.3428 16.9524 18.2524C17.8393 19.4708 17.947 21.1198 17.172 22.463Z",
    fill: "#00A3D8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1488_17722",
    x: 0,
    y: 0,
    width: 34,
    height: 36.5667,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1488_17722"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1488_17722",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCenterwellMapIcon);
export default __webpack_public_path__ + "static/media/centerwell_map_icon.d8f7f370c854a7cf2fd93bfbf5c7f401.svg";
export { ForwardRef as ReactComponent };